import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import { customerservice, loanManagementUrl } from "../../../../config";
import { useNavigate } from "react-router-dom";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride"; // Import Joyride

const base_url = loanManagementUrl.uri;
// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Loan Data page, where you can view the Customer's Loan data.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find a specific loan data by name or other criteria.",
    placement: "bottom",
  },
  // {
  //   target: ".dynamic-table-add-button",
  //   content: "Click this button to add a new collateral detail.",
  //   placement: "right",
  // },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  // {
  //   target: ".dynamic-table-actions",
  //   content: "Select actions like Edit or Deactivate for each collateral detail from this dropdown.",
  //   placement: "left",
  // },
];

const CustomerLoanApplication = () => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const customerId = localStorage.getItem("CustomerId");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const navigate = useNavigate();

  const actions = {
    entity: "Rights",
    isSubright: true,
    dataObject: {
      objectName: "loanApplicationByCustomer",
      parameters: { customerId: parseInt(customerId), },
      inputObjectName: "loans",
      ignoreFields: [
        "CustomerPhone",
        "UpdateDate",
        "CreateDate",
        "LoanApprovalDate",
        "LoanDisburseDate",
        "ExpectedClearDate",
        "LoanClearedDate",
        "RolledOver",
        "ProductId",
        "ArrearsOverDueDays",
        "PrincipleArrears",
        "InterestArrears",
        "IsNonPerforming",
        "RolloverPenalty",
        "IsWrittenOff",
        "LoanDeclineId",
        "IsLoanDeclined",
        "LoanDeclinedReason",
        "WrittenOffDate",
        "RolloverDate",
        "IsFieldOfficerApproved",
        "FieldOfficerComment",
        "IsBranchApproved",
        "BranchComments",
        "IsRegionApproved",
        "RegionComments",
        "IsCompanyApproved",
        "CompanyComments",
        "IsMigrated",
        "RemainingInstallments",
        "MigratedNextInstallmentDate",
        "IsRescheduled",
        "AccountId",
        "ServiceLoans",
        "IsRebooked",
        "ChannelId",
        "BranchId",
        "RegionId",
        "CompanyId",
        "FieldOfficerApprovedBy",
        "FieldOfficerApprovedDate",
        "BranchVerifiedBy",
        "BranchVerifiedDate",
        "CompanyApprovedBy",
        "CompanyApprovedDate",
        "MigratedBy",
        "MigratedDate",
        "DateCreated",
        "CreatedBy",
        "UpdatedDate",
        "UpdatedBy",
        "VerifiedBy",
        "VerifiedDate",
        "IsVerified",
      ],
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
       <Joyride
              steps={rightsTourSteps}
              run={runTour}
              continuous
              showSkipButton
              showProgress
              styles={{
                options: {
                  primaryColor: "#1976d2",
                  zIndex: 10000,
                },
              }}
            />

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => navigate(-1)} variant="contained">
          Back to Customers
        </Button>
         <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <></>
      <DynamicTableForJson
        title="Loans"
        subtitle="Manage Loans"
        // FormComponent={UploadStatementForm}
        base_url={base_url}
        actions={actions}
        filterData={(loan) => loan.LoanDisbursed === 1}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
};

export default CustomerLoanApplication;
